(() => {
  if (window.cartUpsellInitialized) return;

  window.cartUpsellInitialized = true;
  const cartUpsellProgressSliders = new WeakSet();

  const getSectionInnerHTML = (html, selector) => {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHTML.querySelector(selector);

    return element ? element.innerHTML : '';
  };

  const getSectionsToRender = () => {
    const sections = [];
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems?.dataset.id) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents',
      });
    }

    if (mainCartFooter?.dataset.id) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-contents',
      });
    }

    if (document.getElementById('cart-icon-bubble')) {
      sections.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      });
    }

    if (document.getElementById('cart-live-region-text')) {
      sections.push({
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      });
    }

    if (document.getElementById('CartDrawer')) {
      sections.push({
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      });
    }

    return sections;
  };

  const renderSections = (sectionsHTML) => {
    if (!sectionsHTML) return;

    getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHTML = sectionsHTML[section.section];

      if (!target || !sectionHTML) return;

      const elementToReplace = target.querySelector(section.selector) || target;
      const newHTML = getSectionInnerHTML(sectionHTML, section.selector);

      if (newHTML) {
        elementToReplace.innerHTML = newHTML;
      }
    });
  };

  const setButtonLoading = (button, loading) => {
    if (!button) return;

    button.classList.toggle('loading', loading);
    button.toggleAttribute('aria-disabled', loading);
    button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
  };

  const showError = (message = '') => {
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

    if (errors) {
      errors.textContent = message;
    }
  };

  const refreshCartUpsell = (productId) => {
    const cartUpsell = document.querySelector('product-recommendations.cart-upsell');

    if (!cartUpsell || !productId) return;

    cartUpsell.dataset.productId = productId;
    cartUpsell.classList.remove('product-recommendations--loaded');
    cartUpsell.innerHTML = '';

    if (typeof cartUpsell.loadRecommendations === 'function') {
      cartUpsell.loadRecommendations(productId);
    }
  };

  const isCustomCartUpsell = () => !!document.querySelector('.cart-upsell[data-cart-upsell-custom]');

  const replaceCustomCartUpsell = (sectionsHTML) => {
    const footer = document.getElementById('main-cart-footer');
    const footerHTML = footer && sectionsHTML ? sectionsHTML[footer.dataset.id] : null;

    if (!footerHTML) return;

    const current = document.querySelector('.cart-upsell[data-cart-upsell-custom]');
    const parsed = new DOMParser().parseFromString(footerHTML, 'text/html');
    const next = parsed.querySelector('.cart-upsell[data-cart-upsell-custom]');

    if (current && next) {
      current.replaceWith(next);
      initCartUpsellProgress(next.parentElement || document);
    } else if (current && !next) {
      current.remove();
    }
  };

  window.CartUpsell = { isCustomCartUpsell, replaceCustomCartUpsell };

  const updateCartUpsellProgress = (sliderComponent) => {
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const progress = sliderComponent.querySelector('.cart-upsell__progress');
    const progressBar = sliderComponent.querySelector('.cart-upsell__progress-bar');

    if (!slider || !progress || !progressBar) return;

    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const scrollProgress = maxScroll > 0 ? slider.scrollLeft / maxScroll : 0;
    const visiblePercent = slider.scrollWidth > 0 ? (slider.clientWidth / slider.scrollWidth) * 100 : 100;
    const progressSize = Math.max(0, Math.min(visiblePercent, 100));
    const progressPosition = Math.max(0, Math.min(scrollProgress, 1)) * (100 - progressSize);

    progressBar.style.setProperty('--cart-upsell-progress-size', `${progressSize}%`);
    progressBar.style.setProperty('--cart-upsell-progress-position', `${progressPosition}%`);
    progress.setAttribute('aria-valuenow', Math.round(scrollProgress * 100).toString());
  };

  const initCartUpsellProgress = (root = document) => {
    root.querySelectorAll('slider-component.cart-upsell__slider').forEach((sliderComponent) => {
      if (cartUpsellProgressSliders.has(sliderComponent)) {
        updateCartUpsellProgress(sliderComponent);
        return;
      }

      const slider = sliderComponent.querySelector('[id^="Slider-"]');

      if (!slider) return;

      cartUpsellProgressSliders.add(sliderComponent);
      slider.addEventListener('scroll', () => updateCartUpsellProgress(sliderComponent), { passive: true });
      sliderComponent.addEventListener('slideChanged', () => updateCartUpsellProgress(sliderComponent));
      window.addEventListener('resize', () => updateCartUpsellProgress(sliderComponent));

      requestAnimationFrame(() => updateCartUpsellProgress(sliderComponent));
    });
  };

  const observeCartUpsell = () => {
    if (!document.body) return;

    initCartUpsellProgress();

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches('slider-component.cart-upsell__slider')) {
            initCartUpsellProgress(node.parentElement || document);
            return;
          }

          if (node.querySelector('slider-component.cart-upsell__slider')) {
            initCartUpsellProgress(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartUpsell, { once: true });
  } else {
    observeCartUpsell();
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-cart-upsell-form]');

    if (!form) return;

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton?.getAttribute('aria-disabled') === 'true') return;

    const sections = getSectionsToRender();
    const formData = new FormData(form);

    formData.append(
      'sections',
      sections.map((section) => section.section).join(',')
    );
    formData.append('sections_url', window.location.pathname);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    setButtonLoading(submitButton, true);
    showError('');

    fetch(window.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          showError(response.description);
          return;
        }

        renderSections(response.sections);

        if (isCustomCartUpsell()) {
          replaceCustomCartUpsell(response.sections);
        } else {
          refreshCartUpsell(response.product_id);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        showError(window.cartStrings?.error || '');
      })
      .finally(() => {
        setButtonLoading(submitButton, false);
      });
  });
})();
